// Utility for batching state updates to prevent CLS from rapid state changes

class BatchUpdater {
  constructor() {
    this.pendingUpdates = new Set();
    this.isScheduled = false;
  }

  // Batch multiple state updates together to prevent layout shift timing collisions
  batchUpdate(updateFunction) {
    this.pendingUpdates.add(updateFunction);
    
    if (!this.isScheduled) {
      this.isScheduled = true;
      // Use requestAnimationFrame to ensure updates happen at the optimal time
      requestAnimationFrame(() => {
        // Execute all pending updates in a single frame
        this.pendingUpdates.forEach(update => {
          try {
            update();
          } catch (error) {
            console.warn('Batched update error:', error);
          }
        });
        
        this.pendingUpdates.clear();
        this.isScheduled = false;
      });
    }
  }

  // Schedule a delayed update to avoid collision with animation cycles
  delayedUpdate(updateFunction, delay = 0) {
    setTimeout(() => {
      this.batchUpdate(updateFunction);
    }, delay);
  }
}

// Global batch updater instance
export const globalBatchUpdater = new BatchUpdater();

// Hook for using batch updates in components
export const useBatchUpdates = () => {
  return {
    batchUpdate: globalBatchUpdater.batchUpdate.bind(globalBatchUpdater),
    delayedUpdate: globalBatchUpdater.delayedUpdate.bind(globalBatchUpdater),
  };
};
